import { render } from "./FrameMenu.vue?vue&type=template&id=d33869be&scoped=true"
import script from "./FrameMenu.vue?vue&type=script&lang=js"
export * from "./FrameMenu.vue?vue&type=script&lang=js"

import "./FrameMenu.vue?vue&type=style&index=0&id=d33869be&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d33869be"]])

export default __exports__